import {
  type FeatureBillingTier,
  isBillingTierEnabled,
  type SubscriptionFeatureConfig,
} from '@civilgrid/utils/src/common/featureAccess';

// Kept free of component imports so node-env tests can import it without dragging in
// browser-only modules (the CostBreakdown component chain pulls in MSW browser setup).
export const COST_BREAKDOWN_TIERS: { value: FeatureBillingTier; label: string }[] = [
  { value: 'proposal', label: 'Project Lite' },
  { value: 'project', label: 'Project' },
  { value: 'projectPlus', label: 'Project Plus' },
];

/** Tiers the org may select in the cost-breakdown popup (org-disabled tiers hidden). */
export function visibleCostBreakdownTiers(subscription?: SubscriptionFeatureConfig | null) {
  return COST_BREAKDOWN_TIERS.filter((t) => isBillingTierEnabled(t.value, subscription));
}
